/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:25:02
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare திறந்திடுக",
    name2: "முன்பதிவு செய்க",
    name3: "Carlcare மூலம், எந்நேரத்திலும் உங்கள் ஆர்டரை சோதிக்கலாம்.",
    name4: "",
    name5: "வலதுபுறமாக ஸ்லைடு செய்யவும்",
    name6: "சரிபார்ப்பு முடிந்தது",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "சாதன மாடலைத் தேர்ந்தெடுக்கவும்",
    name2: "பழுது விவரம்:",
    name3: "சேவை மையத்தைத் தேர்ந்தெடுக்க தட்டுக",
    name4: "சேவை மையம்:",
    name5: "முன்பதிவு நேரம்:",
    name6: "சாதனப் பிரச்சனையை விரிவாக விளக்குங்கள்!",
    name7: "வந்துசேரும் நேரத்தைத் தேர்ந்தெடுக்க தட்டுக",
    name8: "உங்களைத் தொடர்புகொள்ள ஏதுவாக சரியான தொடர்பு விவரங்களை உள்ளிடுங்கள்",
    name9: "கிடைக்கும் முன்பதிவு நேரம் பின்வருமாறு",
    name10: "உள்ளிடவும்உங்கள் தொலைபேசி எண்ணை உள்ளிடவும்",
    name11: "விலை",
    name12: "தனிப்பட்ட தகவல்:",
    name13: "உங்கள் பெயரை உள்ளிடுங்கள்",
    name14: "சமர்ப்பி",
    name15: "ரத்து",
    name16: "சரி",
  },
  shops: {
    name1: "நீங்கள் தேர்ந்தெடுக்கும் பிராண்டின் அடிப்படையில், பின்வரும் ஸ்டோர்கள் உங்களுக்கு சேவையாற்றலாம்!",
    name2: "விரைவில் அதிக ரீடைல் ஸ்டோர்களில் வரவுள்ளது! எங்களுடன் தொடர்பிலிருங்கள்!",
  },
  price: {
    name1: "பிராண்டு",
    name2: "மாடல்",
    name3: "உருப்படி",
    name4: "விலை",
    name5: "நட்பான நினைவூட்டல்:",
    name6: "இந்த விலைகள் ஒப்பீட்டிற்கு மட்டுமே, அசல் விலை உங்கள் சாதனத்தின் நிலைமைக்கு உட்பட்டது.",
    name7: "சிறப்புக் குறியீடு இல்லை எனில், விலை அலகு உள்ளூர் நாணய அலகில் இருக்கும்.",
    name8: "மன்னிக்கவும்! நடப்பு பிராந்தியத்தில் விலைத் தகவல் ஏதுமில்லை.",
    name11:"கூலி",
    name12:"மொத்த விலை",
    name13: "5. கூலி \"/\" எனில், கூலி குறித்து கடையில் கலந்தாலோசிக்க வேண்டும் என்று அர்த்தம்.",
    item_main_board: "மெயின்போர்டு",
    item_screen_frame: "திரை (ஃபிரேம்)",
    item_screen_screen_frame: "இரண்டாம்நிலைத் திரை (ஃபிரேம்)",
    item_touch_screen: "தொடு திரை",
    item_camera: "\"கேமரா\"",
    item_fixed_focus_camera: "நிலையான ஃபோகஸ் கேமரா",
    item_auto_focus_camera: "ஆட்டோ ஃபோகஸ் கேமரா",
    item_screen: "திரை",
    item_secondary_screen: "இரண்டாம்நிலைத் திரை",
    item_fingerprint_module: "கைரேகை மாட்யூல்",
    item_speaker: "ஸ்பீக்கர்",
    item_receiver: "ரிசீவர்",
    item_small_board: "சிறிய பலகை",
    item_battery_cover: "பேட்டரி கவர்",
    item_battery: "பேட்டரி",
    item_charger: "சார்ஜர்",
    item_usb_cable: "USB கேபிள்",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "தரவு எதுவும்",
    name2: "சேவை வழங்குநர்:",
    name3: "சேவை பிராண்டு:",
    name4: "தொலைபேசி:",
    name5: "ஆர்டர் எண்ணிக்கை:",
    name6: "சேவையின் தரமதிப்பு",
    name7: "சேவைச் சூழல்:",
    name8: "சேவை நடத்தை:",
    name9: "சேவை செயல்திறன்:",
    name10: "சேவைத் தரம்:",
    name11: "வாடிக்கையாளர் மதிப்பீடு",
    name12:"முதல்",
    name13:"மூடப்பட்டது",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare திறந்திடுக",
    name1: "முன்பதிவுத் தகவலை ஸ்கிரீன்ஷாட் எடுத்து அதை முன்னுரிமைச் சேவையை அணுகுவதற்கான ரசீதாகச் சேமித்திடுங்கள்.",
    name2: "வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது",
    name3: "1. தரவை அழித்திடுங்கள்",
    name4: "உங்கள் ஃபோனிலுள்ள முக்கியமான தனிப்பட்ட தரவுகளை முன்கூட்டியே காப்புப்பிரதி எடுத்திடுங்கள்",
    name5: "2. பவர்-ஆன் கடவுச்சொல்லை முடக்கவும்",
    name6: "சேவை மையத்திற்குச் செல்வதற்கு முன், தயவுசெய்து:",
    name7: "சேவை மையம்:",
    name8: "முன்பதிவு நேரம்:",
    name9: "பழுது விவரம்:",
    name10: "சாதன மாடல்:",
    name11: "ஆர்டர் எண்:",
    name12: "ஆர்டர் தகவல்",
  },
  title: {
    
    name1: "பின்வரும் நாடுகளை ஆதரிக்கிறது:",
    name2: "மாடலைத் தேர்வுசெய்க",
    name3: "முன்பதிவு",
    name4: "சேவை மைய விவரங்கள்",
    name5: "சேவை மையத்தைத் தேர்ந்தெடு",
  },
  error: {
    
    name1: "தரவு ஏதுமில்லை. உங்கள் பழுதுத் தகவலை சரிபார்த்திடுங்கள்",
    name2: "மேலும் உதவி தேவையா? எங்களைத் தொடர்புகொள்க.",
    name3: "மன்னிக்கவும், நடப்புப் பிராந்தியத்தில் Carlcare மையம் இல்லை.",
    name4: "முதலில் ஒரு சேவை மையத்தைத் தேர்வுசெய்க",
    name5: "தோல்வி",
    name6: "முதலில் சாதன மாடலைத் தேர்வுசெய்யுங்கள்",
    name7: "விவரங்கள்",
    name8: "உங்கள் தேவைகளை விரிவாக விளக்குங்கள்",
    name9: "",
  },
  add1:{
    "name0": "ta-rIN",
    "name1": "உங்கள் ஆர்டர் உறுதி செய்யப்பட்டு விட்டது. உங்கள் வருகையை நாங்கள் எதிர்நோக்குகிறோம்.",
    "name2": "ஊரை தேர்வுசெய்",
    "name3": "%1$s இலக்க ஃபோன் எண்ணை உள்ளிடுங்கள்.",
    "name4": "வாரநாளின் நேரம்",
    "name5": "\"திங்கட்கிழமை\"",
    "name6": "செவ்வாய்க்கிழமை",
    "name7": "புதன்கிழமை",
    "name8": "வியாழக்கிழமை",
    "name9": "வெள்ளிக்கிழமை",
    "name10": "\"சனிக்கிழமை\"",
    "name11": "\"ஞாயிற்றுக்கிழமை\"",
    "name12": "நாட்டை உள்ளிட்டு தேடவும்"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "மற்றவை",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"திசைதிருப்ப தட்டவும்",
    name3:"ஆர்டருக்குத் தரமதிப்பிட, Carlcare செயலியைத் திறக்கவும்",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"சேவையைத் தேர்ந்தெடுக்கவும்",
    name7:"இலவச சுத்தப்படுத்தல்",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "தவறான தகவல்",
    "cancelReason1": "உரிய நேரத்திற்கு வர முடியாது",
    "cancelReason2": "நகல் ஆர்டர்/எனது ஆர்டர் அல்ல",
    "cancelReason3": "தோல்வி திரும்ப நிகழ்வதில்லை",
    "cancelReason4": "வெறும் சோதனைக்கு/விசாரணைக்கு/நிகழ்வுக்கு/…",
    "cancelReason5": "உயர் விலை",
    "cancelReason6": "பொருள் பற்றாக்குறை",
    "cancelReason7": "வேறுபடுத்திய சேவைகள் இல்லை",
    "cancelReason8": "ஸ்டோர் வெகு தொலைவிலுள்ளது",
    "cancelReason9": "ஸ்டோர் மூடப்பட்டுள்ளது",
    "cancelReason10": "மோசமான சேவை மனோபாவம்",
    "cancelReason11": "மற்ற பிராண்டுகளுக்கான மாற்றீடு/பழுதுநீக்கல்",
    "cancelReason12": "ஸ்டோரைக் கண்டறிய முடியவில்லை",
    "cancelReason13": "மற்றவை",
    "cancelOrder": "ஆர்டரை ரத்துசெய்",
    "reason_dialog_title": "ரத்துசெய்வதற்கான காரணத்தைத் தெரிவித்திடுங்கள்",
    "Cancel": "ரத்து",
    "OK": "சரி",
    "name1": "சரிபார்ப்புக் குறியீடை உள்ளிடு",
    "name2": "தவறான சரிபார்ப்புக் குறியீடு",
    "repair_reservation_detail_canceled": "இந்த ஆர்டர் ரத்தானது!",
    "purchase_cancel_dialog_content": "ஆர்டரை ரத்து செய்வதை உறுதி செய்கிறீர்களா?",
    "yes": "ஆம்",
    "no": "வேண்டாம்"
}
};
